(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.card.component.factory.api'

  require('angular')
    .module(MODULE_NAME, [
      require('../../../api')
    ])
    .factory('SendSms', sendSms)

  sendSms.$inject = ['SdkConfig', 'ThismomentApi']
  function sendSms (SdkConfig, ThismomentApi) {
    return ThismomentApi.configureResource(SdkConfig.get('content_cloud_url') + '/api/ccmt/v1/send-sms')
  };

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/factory/sendsms-api.js